module.exports = __webpack_public_path__ + "static/media/corporatecomm.f0a0bcef.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/corporatecomm.PNG
// module id = 1793
// module chunks = 1